import { Component } from '@theme/component';

export class SpotlightSwiper extends Component {
  /** @type {any} */
  swiper = null;

  connectedCallback() {
    super.connectedCallback();
    this.#init();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }

  async #init() {
    const swiperEl = this.querySelector('.swiper');
    if (!(swiperEl instanceof HTMLElement)) return;

    const prevEl = this.querySelector('.s-spotlight__nav-prev');
    const nextEl = this.querySelector('.s-spotlight__nav-next');

    await this.#ensureSwiperLoaded();

    const style = getComputedStyle(this);
    const readPx = (name, fallback) => {
      const value = parseFloat(style.getPropertyValue(name));
      return Number.isFinite(value) ? value : fallback;
    };
    const gapDesktop = readPx('--spotlight-cards-gap-d', 25);
    const gapMobile = readPx('--spotlight-cards-gap-m', gapDesktop);

    const SwiperCtor = /** @type {any} */ (window).Swiper;
    this.swiper = new SwiperCtor(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: gapMobile,
      watchOverflow: true,
      navigation: { prevEl, nextEl },
      breakpoints: {
        750: {
          spaceBetween: gapDesktop,
        },
      },
    });

    this.#scheduleResync();
  }

  #scheduleResync() {
    const resync = () => this.swiper?.update();
    document.fonts?.ready?.then(resync);
    window.addEventListener('load', resync, { once: true });
  }

  /** @returns {Promise<void>} */
  #ensureSwiperLoaded() {
    if (/** @type {any} */ (window).Swiper) return Promise.resolve();
    return /** @type {Promise<void>} */ (
      new Promise((resolve) => {
        const check = () => {
          if (/** @type {any} */ (window).Swiper) {
            resolve();
            return;
          }
          requestAnimationFrame(check);
        };
        check();
      })
    );
  }
}

if (!customElements.get('spotlight-swiper')) {
  customElements.define('spotlight-swiper', SpotlightSwiper);
}
